// import {
//   Box,
//   Input,
//   Button,
//   List,
//   ListItem,
//   Text,
//   SimpleGrid,
//   Divider
// } from "@chakra-ui/react";
// import { theme } from "../../styles/theme";
// import React, { useContext, useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { api } from "../../services/api";
// import { FaBeer, FaTimes } from 'react-icons/fa';
// import { CityContext } from '../../Context/CityContext';
// import { Link } from 'react-router-dom';
// import { RiCloseCircleLine } from "react-icons/ri";

// export function Search(props) {
//   const [searching, setSearching] = useState(false);
//   const [searchResults, setSearchResults] = useState([]);
//   const [productTypes, setProductTypes] = useState([]);
//   const [isOpen, setIsOpen] = useState(false);
//   const [showResultsList, seShowResultsList] = useState(false);
//   const { cityName } = useContext(CityContext);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [isScrolled, setIsScrolled] = useState(false);

//   useEffect(() => {
//     if (typeof window !== "undefined") {
//       if (window.fbq != null) {
//         window.fbq('trackCustom', 'Search');
//       }
//     }
//   }, []);

//   useEffect(() => {
//     const handleScroll = () => {
//       setIsScrolled(window.scrollY > 0);
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   const mobileWidth = isScrolled ? '95%' : '95%';
//   const mdWidth = isScrolled ? '50%' : '100%';


//   function debounce(func, delay) {
//     let timer;
//     return (...args) => {
//       clearTimeout(timer);
//       timer = setTimeout(() => func.apply(this, args), delay);
//     };
//   }

//   const fetchLiveResults = async (query) => {
//     try {
//       const url = `/search?city_name=${cityName}&query=${query}`;
//       const response = await api.get(url);
//       seShowResultsList(true)
//       setSearchResults(response.data.products);
//     } catch (error) {
//       console.error("Error fetching live search results:", error);
//     } finally {
//       setSearching(false);
//     }
//   };


//   const handleProductSearch = (query) => {
//     const urlParams = new URLSearchParams();
//     if (cityName) urlParams.append("city_name", cityName);
//     if (query) urlParams.append("query", query);

//     navigate(`/produtos?${urlParams.toString()}`, { replace: true });
//     setSearchResults(false)
//     handlefetchProductTypes();
//   };

//   async function handlefetchProductTypes()  {
//     const url = `/api/v1/product_types`
//     const response = await api.get(url)
//     setProductTypes(response.data)
//   }

//   const handleClearSearch = (e) => {
//     e.preventDefault();
//     document.getElementById('search-input').value = '';
//     setSearchResults([]);
//     setSearching(false);
//     const linkPath = e.currentTarget.getAttribute('href');
//     if (linkPath) {
//       window.location.href = linkPath;
//     }
//   }


//   return (
//     <>
//     <Box
//       pt={{ base: '0px', md: '0px' }}
//       display='flex'
//       px={{ base: '0%' , md: '0rem' }}
//       justifyContent={{ base: 'center', md: 'center' }}
//       gap={{ base: '5px', md: '0px' }}
//       width="100%"
//       alignItems='center'
//     >
//       <Box display="flex" alignItems="center" position="relative" width={{ base: mobileWidth, md: mdWidth }}>
//         <Input
//           placeholder="Pesquisar"
//           background='white'
//           size="md"
//           id='search-input'
//           borderRadius="20px"
//           height="31px"
//           onChange={(e) => fetchLiveResults(e.target.value.trim())}
//           onKeyDown={(e) => {
//             if (e.key === "Enter") handleProductSearch(e.target.value.trim());
//           }}
//           color={theme.colors.primary}
//           border='1px solid #343537'
//           _hover={{ borderColor: theme.colors.lightGray }}
//           _focus={{ outline: 'none', boxShadow: 'none' }}
//           width="100%" // Make the input full width
//         />
//         {searching && (
//           <Button
//             position="absolute"
//             right="0"
//             height="31px" // Align with input height
//             bg='transparent'
//             onClick={(e) => handleClearSearch(e)}
//             zIndex='1'
//             fontWeight='light'
//             color='gray'
//             _hover={{ color: theme.colors.primary, bg: 'transparent' }}
//             width={{ base: '15%', md: 'auto' }} // Maintain size without shifting input
//           >
//             <FaTimes />
//           </Button>
//         )}

//         {/* Search Results */}
//         {searchResults?.length > 0 && showResultsList && (
//           <Box
//             position="absolute"
//             top="40px"
//             left="0"
//             width="100%"
//             zIndex="100000"
//             pb="1rem"
//             borderRadius="15px"
//             boxShadow="lg"
//             padding="20px"
//             background="white"
//           >
//             <List width="100%">
//               {searchResults?.length > 0 && (
//                 searchResults.map((product, index) => (
//                   <Link
//                     to={`/produtos/${productTypes?.find(e => e.id === product.product_type_id)?.name.replace(/(%20|\s+)/g, "+")}/${product.name.replace(/(%20|\s+)/g, "+")}`}
//                     key={index}
//                     onClick={handleClearSearch}
//                   >
//                     <ListItem
//                       border="1px solid #D44120"
//                       borderRadius="5px"
//                       p="1%"
//                       my="5px"
//                       color="#D44120"
//                       _hover={{ bg: theme.colors.primary, color: 'white' }}
//                     >
//                       {product.name}
//                     </ListItem>
//                   </Link>
//                 ))
//               )}
//             </List>
//           </Box>
//         )}
//       </Box>
//     </Box>
//     </>
//   )
// }
import React, { useContext, useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../services/api";
import { CityContext } from "../../Context/CityContext";
import { Link } from "react-router-dom";

// ─── Inline SVG Icons ──────────────────────────────────────────────────────────
const IconSearch   = ({ size = 18 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>;
const IconX        = ({ size = 15 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IconClock    = ({ size = 14 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
const IconFire     = ({ size = 14 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2c0 0-5 5-5 10a5 5 0 0 0 10 0C17 7 12 2 12 2z"/><path d="M12 12c0 0-2 2-2 4a2 2 0 0 0 4 0c0-2-2-4-2-4z"/></svg>;
const IconTrophy   = ({ size = 14 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="8 21 12 17 16 21"/><path d="M7 4H17l-1 7H8L7 4z"/><path d="M5 4H4a2 2 0 0 0 0 4h1"/><path d="M19 4h1a2 2 0 0 0 0 4h-1"/><line x1="12" y1="17" x2="12" y2="13"/></svg>;
const IconArrow    = ({ size = 13 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="7" y1="17" x2="17" y2="7"/><polyline points="7 7 7 17 17 17"/></svg>;

// ─── Constants ─────────────────────────────────────────────────────────────────
const HISTORY_KEY  = "boozen_search_history";
const MAX_HISTORY  = 5;
const ORANGE       = "#fc8f04";
const DARK_ORANGE  = "#b83518";
const GREEN        = "#004a33";
const LIGHT_BG     = "#fffaf8";

// ─── LocalStorage helpers ──────────────────────────────────────────────────────
const getHistory = () => { try { return JSON.parse(localStorage.getItem(HISTORY_KEY) || "[]"); } catch { return []; } };
const saveToHistory = (q) => {
  if (!q?.trim()) return;
  const h = getHistory().filter(x => x !== q);
  h.unshift(q);
  localStorage.setItem(HISTORY_KEY, JSON.stringify(h.slice(0, MAX_HISTORY)));
};
const removeFromHistory = (q) => localStorage.setItem(HISTORY_KEY, JSON.stringify(getHistory().filter(x => x !== q)));

// ─── Debounce ─────────────────────────────────────────────────────────────────
function debounce(fn, ms) { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; }

// ─── Slug ──────────────────────────────────────────────────────────────────────
const slugify = (s = "") => s.replace(/(%20|\s+)/g, "+");
const productHref = (p) => `/produtos/${slugify(p.product_type_name || "")}/${slugify(p.name)}`;

// ─── Format price ─────────────────────────────────────────────────────────────
const fmt = (v) => v != null ? `R$${Number(v).toFixed(2).replace(".", ",")}` : null;

// ─── Highlight query inside text ──────────────────────────────────────────────
function Hl({ text = "", q = "" }) {
  if (!q.trim()) return <>{text}</>;
  const i = text.toLowerCase().indexOf(q.toLowerCase());
  if (i === -1) return <>{text}</>;
  return <>{text.slice(0, i)}<mark style={{ background: `${ORANGE}22`, color: ORANGE, fontWeight: 700, borderRadius: 2, padding: 0 }}>{text.slice(i, i + q.length)}</mark>{text.slice(i + q.length)}</>;
}

// ─── Product image with fallback emoji ────────────────────────────────────────
function ProductThumb({ url, name }) {
  const [err, setErr] = useState(false);
  if (!url || err) return (
    <div style={{ width: 44, height: 44, borderRadius: 8, background: `${ORANGE}12`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: 22 }}>🍺</div>
  );
  return <img src={url} alt={name} onError={() => setErr(true)} style={{ width: 44, height: 44, borderRadius: 8, objectFit: "cover", flexShrink: 0, border: "1px solid #f0ede9" }} />;
}

// ─── Skeleton row ─────────────────────────────────────────────────────────────
function SkeletonRow() {
  return (
    <div style={{ display: "flex", gap: 10, padding: "8px 14px", alignItems: "center" }}>
      <div style={{ width: 44, height: 44, borderRadius: 8, background: "#f0ede9", flexShrink: 0 }} />
      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>
        <div style={skel("70%")} />
        <div style={skel("40%")} />
      </div>
    </div>
  );
}
const skel = (w) => ({ height: 12, width: w, background: "linear-gradient(90deg,#f0ede9 25%,#fdf9f7 50%,#f0ede9 75%)", backgroundSize: "200% 100%", borderRadius: 6, animation: "bzSkel 1.4s infinite" });

// ─── Section label ────────────────────────────────────────────────────────────
function SectionLabel({ icon, label, color }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "10px 14px 5px", fontSize: 10.5, fontWeight: 800, letterSpacing: "0.1em", textTransform: "uppercase", color: color || "#aaa" }}>
      {icon} {label}
    </div>
  );
}

// ─── Compact product row (search results) ─────────────────────────────────────
function ProductRow({ product, query, highlighted, onHover, onClick }) {
  const discount = product.discount;
  return (
    <Link to={productHref(product)} onClick={onClick} style={{ textDecoration: "none", display: "block" }}>
      <div
        onMouseEnter={onHover}
        style={{
          display: "flex", alignItems: "center", gap: 10,
          padding: "7px 14px", cursor: "pointer",
          background: highlighted ? "#fff5f2" : "transparent",
          transition: "background 0.1s",
        }}
      >
        <ProductThumb url={product.photo_url} name={product.name} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 13.5, color: "#1a1a1a", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            <Hl text={product.name} q={query} />
          </div>
          <div style={{ fontSize: 11.5, color: "#888", marginTop: 1 }}>
            <Hl text={product.brand} q={query} />
            {product.size ? ` · ${product.size}` : ""}
          </div>
        </div>
        <div style={{ textAlign: "right", flexShrink: 0 }}>
          {product.unit_price != null && (
            <div style={{ fontSize: 13, fontWeight: 700, color: ORANGE }}>{fmt(product.unit_price)}<span style={{ fontSize: 10, fontWeight: 400, color: "#aaa" }}>/un</span></div>
          )}
          {discount > 0 && (
            <div style={{ fontSize: 10, background: `${ORANGE}15`, color: ORANGE, borderRadius: 99, padding: "1px 5px", fontWeight: 700, marginTop: 2, display: "inline-block" }}>{discount}% OFF</div>
          )}
        </div>
        <span style={{ color: "#ddd", display: "flex" }}><IconArrow /></span>
      </div>
    </Link>
  );
}

// ─── Rich product card (trending — horizontal scroll on mobile) ───────────────
function TrendingCard({ product, onClick, rank }) {
  return (
    <Link to={productHref(product)} onClick={onClick} style={{ textDecoration: "none" }}>
      <div style={{
        width: 130, flexShrink: 0, borderRadius: 12, border: "1px solid #f0ede9",
        background: "#fff", overflow: "hidden", cursor: "pointer",
        transition: "box-shadow 0.15s, transform 0.15s",
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
      }}
        onMouseEnter={e => { e.currentTarget.style.boxShadow = "0 4px 16px rgba(212,65,32,0.15)"; e.currentTarget.style.transform = "translateY(-2px)"; }}
        onMouseLeave={e => { e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)"; e.currentTarget.style.transform = ""; }}
      >
        {/* Image area */}
        <div style={{ position: "relative", height: 90, background: `${ORANGE}08`, display: "flex", alignItems: "center", justifyContent: "center" }}>
          {product.photo_url
            ? <img src={product.photo_url} alt={product.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            : <span style={{ fontSize: 36 }}>🍺</span>
          }
          {rank != null && (
            <div style={{ position: "absolute", top: 5, left: 5, width: 18, height: 18, borderRadius: "50%", background: ORANGE, color: "#fff", fontSize: 10, fontWeight: 800, display: "flex", alignItems: "center", justifyContent: "center" }}>
              {rank}
            </div>
          )}
          {product.discount > 0 && (
            <div style={{ position: "absolute", top: 5, right: 5, background: ORANGE, color: "#fff", fontSize: 10, fontWeight: 800, borderRadius: 99, padding: "1px 5px" }}>
              -{product.discount}%
            </div>
          )}
        </div>
        {/* Info */}
        <div style={{ padding: "7px 8px 8px" }}>
          <div style={{ fontSize: 11.5, color: "#1a1a1a", fontWeight: 600, lineHeight: 1.3, overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>
            {product.name}
          </div>
          <div style={{ fontSize: 10.5, color: "#aaa", marginTop: 2 }}>{product.brand}</div>
          {product.unit_price != null && (
            <div style={{ fontSize: 13, fontWeight: 800, color: ORANGE, marginTop: 4 }}>{fmt(product.unit_price)}<span style={{ fontSize: 9, fontWeight: 400, color: "#bbb" }}>/un</span></div>
          )}
          {product.market_price != null && product.unit_price != null && product.market_price > product.unit_price && (
            <div style={{ fontSize: 10, color: "#bbb", textDecoration: "line-through" }}>{fmt(product.market_price)}</div>
          )}
        </div>
      </div>
    </Link>
  );
}

// ─── Horizontal scroll section ────────────────────────────────────────────────
function HScrollSection({ children }) {
  return (
    <div style={{ display: "flex", gap: 10, overflowX: "auto", padding: "4px 14px 12px", scrollbarWidth: "none", msOverflowStyle: "none" }}>
      {children}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════════════
export function Search(props) {
  const [query, setQuery]             = useState("");
  const [results, setResults]         = useState([]);
  const [lastFetchedQuery, setLastFetchedQuery] = useState(""); // query dos resultados em cache
  const [loading, setLoading]         = useState(false);
  const [focused, setFocused]         = useState(false);
  const [history, setHistory]         = useState(getHistory());
  const [highlighted, setHL]          = useState(-1);
  const [trending, setTrending]       = useState({ best_sellers: [], top_searched: [] });
  const [trendLoaded, setTrendLoaded] = useState(false);

  const { cityName }  = useContext(CityContext);
  const navigate      = useNavigate();
  const inputRef      = useRef(null);
  const wrapperRef    = useRef(null);
  const abortRef      = useRef(null);

  // ── Fetch trending once on mount ─────────────────────────────────────────
  useEffect(() => {
    api.get(`/trending?city_name=${cityName || ""}`)
      .then(r => { setTrending(r.data); setTrendLoaded(true); })
      .catch(() => setTrendLoaded(true));
  }, [cityName]);

  // ── Close on outside click ───────────────────────────────────────────────
  useEffect(() => {
    const handler = (e) => { if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setFocused(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // ── Debounced live fetch ─────────────────────────────────────────────────
  const fetchResults = useCallback(debounce(async (q) => {
    if (!q.trim()) { setResults([]); setLastFetchedQuery(""); setLoading(false); return; }
    if (abortRef.current) abortRef.current.abort();
    abortRef.current = new AbortController();
    setLoading(true);
    try {
      const res = await api.get(`/search?city_name=${cityName}&query=${q}`, { signal: abortRef.current.signal });
      setResults(res.data.products || []);
      setLastFetchedQuery(q);
    } catch (e) {
      if (e?.name !== "CanceledError" && e?.name !== "AbortError") setResults([]);
    } finally { setLoading(false); }
  }, 280), [cityName]);

  // ── Handlers ─────────────────────────────────────────────────────────────
  function handleChange(e) {
    const v = e.target.value;
    setQuery(v);
    setHL(-1);
    fetchResults(v);
  }

  function doNavigate(q) {
    if (!q?.trim()) return;
    saveToHistory(q.trim());
    setHistory(getHistory());
    const p = new URLSearchParams();
    if (cityName) p.append("city_name", cityName);
    p.append("query", q.trim());
    setFocused(false);
    navigate(`/produtos?${p.toString()}`);
  }

  // Fechar dropdown sem apagar query nem resultados
  function handleClose() { setFocused(false); }

  function handleClear() { setQuery(""); setResults([]); setLastFetchedQuery(""); setHL(-1); inputRef.current?.focus(); }

  // Ao refocar: se já tem query mas os resultados são de uma query diferente (ou não tem), busca de novo
  function handleFocus() {
    setFocused(true);
    if (query.trim() && query !== lastFetchedQuery) {
      fetchResults(query);
    }
  }

  function handleRemoveHistory(e, item) {
    e.stopPropagation(); e.preventDefault();
    removeFromHistory(item);
    setHistory(getHistory());
  }

  // ── Keyboard nav ─────────────────────────────────────────────────────────
  const navItems = query.trim()
    ? results.slice(0, 8)
    : [];

  function handleKeyDown(e) {
    if (e.key === "ArrowDown") { e.preventDefault(); setHL(i => Math.min(i + 1, navItems.length - 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setHL(i => Math.max(i - 1, -1)); }
    else if (e.key === "Enter") {
      if (highlighted >= 0 && navItems[highlighted]) {
        navigate(productHref(navItems[highlighted]));
        handleClose();
      } else { doNavigate(query); }
    } else if (e.key === "Escape") { setFocused(false); inputRef.current?.blur(); }
  }

  const showDropdown  = focused;
  // Mostra resultados quando tem query — independente de ter resultado ou não
  const showResults   = query.trim().length > 0;
  // Mostra estado vazio (history/trending) só quando input está vazio
  const showEmpty     = !showResults;
  const hasTrending   = trendLoaded && (trending.best_sellers.length > 0 || trending.top_searched.length > 0);

  return (
    <>
      <style>{`
        @keyframes bzDrop  { from { opacity:0; transform:translateY(-6px) scale(.98); } to { opacity:1; transform:translateY(0) scale(1); } }
        @keyframes bzSkel  { 0% { background-position:200% 0; } 100% { background-position:-200% 0; } }
        .bz-hscroll::-webkit-scrollbar { display:none; }
        .bz-input::placeholder { color:#bbb; }
      `}</style>

      <div ref={wrapperRef} style={{ position: "relative", width: "100%", fontFamily: "'DM Sans','Segoe UI',sans-serif" }}>

        {/* ── Search bar ───────────────────────────────────────────────────── */}
        <div style={{
          display: "flex", alignItems: "center",
          background: "#fff",
          border: `2px solid ${focused ? ORANGE : "#e0e0e0"}`,
          borderRadius: 999, height: 42, padding: "0 10px 0 16px", gap: 8,
          boxShadow: focused ? `0 0 0 3px ${ORANGE}22` : "0 1px 4px rgba(0,0,0,0.08)",
          transition: "border-color .18s, box-shadow .18s",
        }}>
          <span style={{ color: focused ? ORANGE : "#aaa", display: "flex", flexShrink: 0, transition: "color .18s" }}>
            <IconSearch />
          </span>
          <input
            ref={inputRef}
            className="bz-input"
            type="text"
            value={query}
            placeholder="Buscar cervejas, marcas, categorias..."
            autoComplete="off"
            spellCheck={false}
            onChange={handleChange}
            onFocus={() => handleFocus()}
            onKeyDown={handleKeyDown}
            style={{ flex: 1, border: "none", outline: "none", background: "transparent", fontSize: 15, fontFamily: "inherit", color: "#1a1a1a", caretColor: ORANGE, minWidth: 0 }}
            aria-label="Buscar produtos"
          />
          {query && (
            <button onClick={handleClear} tabIndex={-1} style={{ display: "flex", alignItems: "center", justifyContent: "center", background: "#f0f0f0", border: "none", borderRadius: "50%", width: 24, height: 24, cursor: "pointer", color: "#777", flexShrink: 0, transition: "background .15s" }}
              onMouseEnter={e => { e.currentTarget.style.background = "#ffe0d8"; e.currentTarget.style.color = ORANGE; }}
              onMouseLeave={e => { e.currentTarget.style.background = "#f0f0f0"; e.currentTarget.style.color = "#777"; }}
            >
              <IconX />
            </button>
          )}
        </div>

        {/* ── Dropdown ────────────────────────────────────────────────────── */}
        {showDropdown && (
          <div style={{
            position: "absolute", top: "calc(100% + 8px)", left: 0, right: 0,
            background: "#fff", borderRadius: 16, zIndex: 99999,
            boxShadow: "0 8px 40px rgba(0,0,0,0.13), 0 2px 8px rgba(0,0,0,0.07)",
            border: "1px solid #f0ede9",
            animation: "bzDrop .15s cubic-bezier(.23,1,.32,1)",
          }}>

            {/* ── Live search results (scroll só aqui) ─────────────────── */}
            {showResults && (
              <div style={{ maxHeight: "60vh", overflowY: "auto", borderRadius: "16px 16px 0 0" }}>
                {loading
                  ? [0,1,2,3].map(i => <SkeletonRow key={i} />)
                  : results.length > 0
                    ? <>
                        {results.map((p, i) => (
                          <ProductRow
                            key={p.id || i}
                            product={p}
                            query={query}
                            highlighted={i === highlighted}
                            onHover={() => setHL(i)}
                            onClick={handleClose}
                          />
                        ))}
                        <div style={{ height: 1, background: "#f4f0ed", margin: "2px 0" }} />
                        {/* Ver todos — fora do scroll, sempre visível */}
                        <div
                          onClick={() => doNavigate(query)}
                          style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", cursor: "pointer" }}
                          onMouseEnter={e => e.currentTarget.style.background = "#fff5f2"}
                          onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                        >
                          <span style={{ color: ORANGE, display: "flex" }}><IconSearch size={15} /></span>
                          <span style={{ fontSize: 13.5, fontWeight: 600, color: ORANGE }}>Ver todos os resultados para "{query}"</span>
                        </div>
                      </>
                    : (
                        <div style={{ padding: "24px 14px", textAlign: "center" }}>
                          <div style={{ fontSize: 32, marginBottom: 6 }}>🍺</div>
                          <div style={{ fontSize: 14, color: "#888", fontWeight: 500 }}>Nenhum produto encontrado</div>
                          <div style={{ fontSize: 12, color: "#bbb", marginTop: 3 }}>Tente outro nome, marca ou categoria</div>
                        </div>
                      )
                }
              </div>
            )}

            {/* ── Empty state: history + trending ───────────────────────── */}
            {!showResults && (
              <>
                {/* Histórico */}
                {history.length > 0 && (
                  <>
                    <SectionLabel icon={<IconClock />} label="Buscas recentes" />
                    {history.map((item) => (
                      <div key={item}
                        onClick={() => doNavigate(item)}
                        style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 14px", cursor: "pointer" }}
                        onMouseEnter={e => e.currentTarget.style.background = "#fff5f2"}
                        onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                      >
                        <span style={{ color: "#ccc", display: "flex" }}><IconClock /></span>
                        <span style={{ flex: 1, fontSize: 14, color: "#333" }}>{item}</span>
                        <button
                          onClick={e => handleRemoveHistory(e, item)}
                          tabIndex={-1}
                          style={{ background: "none", border: "none", color: "#ccc", cursor: "pointer", display: "flex", padding: 2 }}
                          onMouseEnter={e => e.currentTarget.style.color = ORANGE}
                          onMouseLeave={e => e.currentTarget.style.color = "#ccc"}
                        >
                          <IconX size={13} />
                        </button>
                      </div>
                    ))}
                    <div style={{ height: 1, background: "#f4f0ed", margin: "4px 0" }} />
                  </>
                )}

                {/* Mais vendidos */}
                {trending.best_sellers?.length > 0 && (
                  <>
                    <SectionLabel icon={<IconTrophy size={13} />} label="Mais vendidos" color={GREEN} />
                    <div className="bz-hscroll" style={{ display: "flex", gap: 10, overflowX: "auto", padding: "4px 14px 12px", scrollbarWidth: "none" }}>
                      {trending.best_sellers.map((p, i) => (
                        <TrendingCard key={p.id || i} product={p} onClick={handleClose} rank={i + 1} />
                      ))}
                    </div>
                    <div style={{ height: 1, background: "#f4f0ed", margin: "2px 0" }} />
                  </>
                )}


                {/* Fallback se ainda não carregou trending */}
                {!trendLoaded && (
                  <div style={{ padding: "8px 0" }}>
                    {[0,1,2].map(i => <SkeletonRow key={i} />)}
                  </div>
                )}

                <div style={{ padding: "8px 14px", fontSize: 11, color: "#ccc", textAlign: "center", borderTop: "1px solid #f4f0ed" }}>
                  ↑↓ navegar · Enter buscar · Esc fechar
                </div>
              </>
            )}

          </div>
        )}
      </div>
    </>
  );
}
